/**
 * @file Helper method to bridge url clicks using postMessage
 */
import appCan from '@@/bits/app_can'
import device from '@@/bits/device'
import { buildUrlFromPath, navigateTo } from '@@/bits/location'
import { getNativeLinkPayloadForInternalLink } from '@@/bits/native_link_payload'
import { isInternalUrl, isMakePageUrlFormat } from '@@/bits/url'
import { openLink } from '@@/native_bridge/actions'
import postMessage from '@@/native_bridge/post_message'
import type { LinkType } from '@@/native_bridge/types'
import { NativeAppOpenLink } from '@@/pinia/native_app'

export function bridgeUrlClick(event: Event, url: string, bridgeTarget?: LinkType): void {
  if (!appCan('postMessage')) {
    return
  }
  event.preventDefault()
  navigateToUrlBridged(url, bridgeTarget)
}

export function navigateToUrlBridged(url: string, bridgeTarget?: LinkType): void {
  // prepend host and protocol to links if they are not already there
  if (!/^https?:\/\//.test(url) && !url.startsWith('//')) {
    url = buildUrlFromPath(url)
  }

  if (device.app && appCan('postMessage')) {
    let linkPayload: Omit<NativeAppOpenLink, 'url'>

    if (bridgeTarget) {
      linkPayload = { linkType: bridgeTarget }
    } else {
      if (isMakePageUrlFormat(url)) {
        linkPayload = { linkType: 'internal', contentCategory: 'page', contentSubcategory: 'dashboard-make' }
      } else if (isInternalUrl(url)) {
        linkPayload = getNativeLinkPayloadForInternalLink(url)
      } else {
        linkPayload = { linkType: 'external' }
      }
    }

    postMessage(openLink({ url, ...linkPayload }))
  } else {
    navigateTo(url, { target: '_blank' })
  }
}
